import moment from 'moment'
import * as ActionTypes from '../constants/actionTypes'
import api from '../utils/api'
import getFieldFromItem, { fieldLang, getFieldWithLangKey, getNewObjFromDirtyLangObj } from '../utils/getFieldFromItem'

export const keys = []

export const editForm = formFieldsChange => ({
  type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_ENTER_RESET,
})

export const fetchItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_FETCHITEM_LOAD })
  try {
    let item = await api.get(`cv_scholarship_and_prizes/${params.id}`)
    item = {
      ...item,
      ...getFieldWithLangKey({
        fieldTitle: 'data', objString: item.data, languages: fieldLang,
      }),
      toYear: moment(item.toYear),
      fromYear: moment(item.fromYear),
    }
    dispatch({
      type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_FETCHITEM_SUCCEED,
      item,
    })
    const field = getFieldFromItem(
      item,
      //keys,
    )
    dispatch({
      type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_EDITFORM_CHANGE,
      field,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_FETCHITEM_FAIL,
      fetchItemError: error.message,
    })
  }
}

export const createItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_CREATEITEM_LOAD })
  try {
    await api.create(`cv_scholarship_and_prizes`, {
      ...getNewObjFromDirtyLangObj({ fieldTitle: 'data', languages: fieldLang, obj: params }),
      fromYear: params.fromYear? moment(params.fromYear).format('YYYY-MM-DD'): null,
      toYear:   params.toYear?   moment(params.toYear).format('YYYY-MM-DD')  : null,
    })
    dispatch({ type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZELIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_CREATEITEM_FAIL,
      createItemError: error.message,
    })
  }
}

export const editItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_EDITITEM_LOAD })
  try {
    await api.patch(`cv_scholarship_and_prizes/${params.id}`, {
      ...getNewObjFromDirtyLangObj({ fieldTitle: 'data', languages: fieldLang, obj: params }),
      fromYear: params.fromYear? moment(params.fromYear).format('YYYY-MM-DD'): null,
      toYear:   params.toYear?   moment(params.toYear).format('YYYY-MM-DD')  : null,
    })
    dispatch({ type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_EDITITEM_SUCCEED })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_EDITITEM_FAIL,
      editItemError: error.message,
    })
  }
}

export const deleteItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_DELETEITEM_LOAD })
  try {
    await api.delete(`cv_scholarship_and_prizes/${params.id}`)
    dispatch({ type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_SCHOLARSHIP_AND_PRIZEFORM_DELETEITEM_FAIL,
      deleteItemError: error.message,
    })
  }
}
